import platformTemplateFallbacks from '../assets/platformTemplateFallbacks.json';
import { cloneProjectVersion, type ProjectVersion, type ProjectVersionFields } from './projectVersions';

type BundledTemplateProjectData = {
  projectString: string;
  apiMetadata: Required<ProjectVersionFields>;
};

type BundledTemplateProjectAsset = Record<
  string,
  {
    projectString: string;
    apiMetadata: {
      version: ProjectVersion;
      frameworkVersion: ProjectVersion;
    };
  }
>;

const BUNDLED_TEMPLATE_PROJECTS = platformTemplateFallbacks as BundledTemplateProjectAsset;

export function getBundledTemplateProjectData(shareCode: string): BundledTemplateProjectData | null {
  const bundled = BUNDLED_TEMPLATE_PROJECTS[shareCode];
  if (!bundled) return null;

  return {
    projectString: bundled.projectString,
    apiMetadata: {
      version: cloneProjectVersion(bundled.apiMetadata.version),
      frameworkVersion: cloneProjectVersion(bundled.apiMetadata.frameworkVersion),
    },
  };
}
